import DatePickerSettings from './DatePickerSettings';

export default DatePickerSettings;
